import {deserialize, serialize, inheritSerialization, deserializeAs} from "cerialize";

import BaseEntity from "./BaseEntity";
import AspekBankSoal from "./AspekBankSoal";

@inheritSerialization(BaseEntity)
export default class BankSoal extends BaseEntity {

    @serialize
    @deserialize
    public nama: string = "";

    @serialize
    @deserialize
    public pendidikan: string = "";

    @serialize
    @deserialize
    public tahun: string = "";

    @serialize
    @deserializeAs(AspekBankSoal)
    public aspeks: Array<AspekBankSoal> = [];

}